import { Component, OnInit, ViewChild, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { Client } from 'src/app/entity/exhibitor';
import { ClientService } from 'src/app/service/client.service';
import { Table } from 'primeng/table';
import { type } from 'jquery';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Router } from '@angular/router';
declare var jsPDF: any;
@Component({
  selector: 'app-constructeurs',
  templateUrl: './constructeurs.component.html',
  styleUrls: ['./constructeurs.component.css']
})
export class ConstructeursComponent implements OnInit,OnChanges {

  listArchives: Observable<Client[]>;
  listClients: Client[];
  loading: boolean;
  @ViewChild('dt' ) DataTableVar: Table;
  cols: any[];
  colsExport: any[];
  exportColumns: any[];
  types: { label: string; value: string; }[];
  @Input() index:number;
  constructor(private clientService: ClientService, private exhibitorService: ExhibitorService, private router: Router) {

  }

  ngOnInit() {
    this.cols = [
      { field: 'raisonSocial', header: 'Raison Social', width: '40%' },

 
      { field: 'finance', header: 'Payé', width: '200px' },
      { field: 'clientsConstructeurs', header: 'Clients', width: '200px' },
      
      { field: 'observation', header: 'Note', width: '30%' },
    ];
    this.colsExport = [
      { field: 'raisonSocial', header: 'Raison Social', width: '40%' },

      
      { field: 'concretiserPar', header: 'Etat', width: '200px' },
      { field: 'clientsConstructeurs', header: 'Clients', width: '200px' },

      { field: 'observation', header: 'Note', width: '30%' },

    ];
    this.types = [
      { label: 'Payé', value: "true" },
      { label: 'Non Payé', value: 'false' },
    

    ];


    this.exportColumns = this.colsExport.map(col => ({ title: col.header, dataKey: col.field }));

    this.loading = true;

  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.index==5 && !this.listArchives){
      this.listArchives = this.clientService.findbyType('P');
      this.listArchives.subscribe(result=>{
        this.listClients=result
      })
    }
 
  }

  


  convertType(t: string): string {
    let type: string;
    if (t == "E")
      type = "Exposant"
    else if (t == "ES")
      type = "Exposant Sponsor"
    else if (t == "C")
      type = "Co-Exposant"
    return type;
  }

 
  exportExcel(){
    
  }
  exportPdf() {
 

this.listClients.forEach(element => {
  element.concretiserPar=element.finance ? 'Payé' : 'Non Payé';
});

    const doc = new jsPDF('l');
    doc.filename = "cwxc";
    if (this.DataTableVar.filteredValue){

      this.DataTableVar.filteredValue.forEach(element => {
        element.concretiserPar=element.finance ? 'Payé' : 'Non Payé';
      });
      

      doc.autoTable(

        this.exportColumns, this.DataTableVar.filteredValue, {


        margin: { horizontal: 7 },

        columnStyles: { 0: { columnWidth: 80 }, 1: { columnWidth: 20 }, 2: { columnWidth: 70 } }
      });
    }
    else doc.autoTable(
      this.exportColumns, this.listClients, {


      margin: { horizontal: 7 },

      columnStyles: { 0: { columnWidth: 80 }, 1: { columnWidth: 20 }, 2: { columnWidth: 70 } }
    });

    doc.save('Liste des stands.pdf');


  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
}
